/* eslint-disable */
import { PrizeManager } from './prizeManager.js'

export class MonthlyRaceManager {
  static MONTHLY_PRIZES = {
    short: {
      name: 'Sprint Champion Trophy',
      description: 'Awarded for the fastest 800m time of the month',
      value: 25000,
      prizeDisplay: '25,000G'
    },
    medium: {
      name: 'Classic Champion Trophy',
      description: 'Awarded for the fastest 2000m time of the month',
      value: 35000,
      prizeDisplay: '35,000G'
    },
    long: {
      name: 'Endurance Champion Trophy',
      description: 'Awarded for the fastest 5000m time of the month',
      value: 50000,
      prizeDisplay: '50,000G'
    }
  }

  static getMonthFromDay(day) {
    return Math.floor((day - 1) / 32) + 1;
  }

  static isMonthEnd(currentDay, nextDay) {
    return this.getMonthFromDay(currentDay) !== this.getMonthFromDay(nextDay)
  }

  static getMonthlyBestTimes(chocobos, currentMonth) {
    const bestTimes = {
      short: { normalized: Infinity, raw: Infinity, chocobo: null },
      medium: { normalized: Infinity, raw: Infinity, chocobo: null },
      long: { normalized: Infinity, raw: Infinity, chocobo: null }
    }
  
    chocobos.forEach(chocobo => {
      if (!chocobo.raceHistory) return;
  
      chocobo.raceHistory.forEach(race => {
        if (!race.day) return;
        
        const raceMonth = this.getMonthFromDay(race.day);
        if (raceMonth === currentMonth) {
          let finishTime = race.finishTime;
          if (typeof finishTime === 'string') {
            finishTime = this.parseTimeToSeconds(finishTime);
          }
  
          if (race.raceType && finishTime) {
            // Normalize time based on chocobo level and stats
            const normalizedTime = this.normalizeTime(finishTime, chocobo, race.raceType);
            
            if (normalizedTime < bestTimes[race.raceType].normalized) {
              bestTimes[race.raceType] = { 
                normalized: normalizedTime,
                raw: finishTime,
                chocobo
              };
            }
          }
        }
      });
    });
    
  
    return bestTimes;
  }

  static processMonthEnd(gameStore) {
    // We need to check the PREVIOUS month's results, not the current month!
    // When we transition from day 32 to 33, we're already in month 2
    const previousMonth = this.getMonthFromDay(gameStore.currentDay - 1);
    
    const bestTimes = this.getMonthlyBestTimes(gameStore.chocobos, previousMonth);
    
    const rewards = [];
    let totalPrizeMoney = 0;

    // Initialize inventory if needed
    if (!gameStore.playerOwner.inventory) {
      gameStore.playerOwner.inventory = [];
    }

    // Check each category for player victories
    Object.entries(bestTimes).forEach(([category, result]) => {
      if (result.chocobo && gameStore.playerOwner.chocoboIds.includes(result.chocobo.id)) {
        // Player won category
        
        const prize = this.MONTHLY_PRIZES[category];
        const award = {
          name: prize.name,
          description: prize.description,
          value: prize.value,
          prizeDisplay: prize.prizeDisplay,
          chocobo: result.chocobo.name,
          time: result.raw,
          month: previousMonth,
          year: Math.floor((gameStore.currentDay - 1) / (32 * 12)) + 7,
          type: 'monthly'
        };
        
        // Award trophy
        const trophyItem = {
          ...award,
          dateAwarded: new Date().toISOString()
        };
        gameStore.playerOwner.inventory.push(trophyItem);
        
        // Award item prize from prize pool
        const itemPrize = PrizeManager.selectRandomPrize(category);
        if (itemPrize) {
          gameStore.playerOwner.inventory.push(itemPrize);
          rewards.push({
            ...award,
            itemPrize: itemPrize
          });
        } else {
          rewards.push(award);
        }
        
        // Added to inventory
        totalPrizeMoney += prize.value;
      }
    });

    // Award prize money
    if (totalPrizeMoney > 0) {
      gameStore.playerOwner.money += totalPrizeMoney;
    }

    // Save game state
    if (rewards.length > 0) {
      gameStore.saveGame();
    }
    return rewards;
  }

  static normalizeTime(rawTime, chocobo, raceType) {
    // Level factor: higher level chocobos get a small advantage
    const levelFactor = 1 + (Math.log(chocobo.level) / Math.log(40)) * 0.2;
    
    const speedWeight = raceType === 'short' ? 0.7 : 
                       raceType === 'medium' ? 0.5 : 0.3;
    const staminaWeight = 1 - speedWeight;
    
    // Stat factor: better stats provide advantage
    const statFactor = 1 + ((chocobo.speed * speedWeight + 
                            chocobo.stamina * staminaWeight) / 300) * 0.3;
    
    // FIXED: Divide by factors instead of multiply to give advantage to better chocobos
    return rawTime / (levelFactor * statFactor);
  }


  static parseTimeToSeconds(timeString) {
    const [minutes, rest] = timeString.split(':')
    const [seconds, milliseconds] = rest.split('.')
    return parseInt(minutes) * 60 + parseInt(seconds) + parseInt(milliseconds) / 1000
  }
}